var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper",attrs:{"id":"main-wrapper"}},[_c('MainNav'),_c('router-view'),_c('RGFooter',{attrs:{"year":_vm.currentYear()}}),_c('CookieModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }